import { DirectUpload }      from '@rails/activestorage'
import ApplicationController from '../../support/application_controller'

export default class extends ApplicationController {

  static targets = [
    'emptyState',
    'error',
    'fileDetails',
    'fileInput',
    'fileName',
    'preview',
    'signedId'
  ]

  static values = {
    acceptedFiles: String,
    maxFileSize:   Number
  }

  // ==== Controllers

  // ==== Actions

  choose(event) {
    event.preventDefault()
    this.fileInputTarget.click()
  }

  upload() {
    const [file] = this.fileInputTarget.files

    this.fileInputTarget.value = ''
    if (file) this.start(file)
  }

  remove() {
    if (this.xhr) this.xhr.abort()

    this.signedIdTarget.value = ''
    this.previewTarget.classList.add('u-hide')
    this.emptyStateTarget.classList.remove('u-hide')
  }

  // ==== Getters

  get acceptedFiles() {
    return this.acceptedFilesValue.split(',')
  }

  // ==== Setters

  // ==== Private

  start(file) {
    this.signedIdTarget.value = ''
    this.showPreview(file)

    const error = this.validate(file)
    if (error) {
      this.errorTarget.textContent = error
      return
    }

    new DirectUpload(file, this.fileInputTarget.dataset.directUploadUrl, this).create((uploadError, blob) => {
      this.xhr = null
      this.fileDetailsTarget.textContent = this.fileDetails(file)

      if (uploadError) {
        this.errorTarget.textContent = uploadError
        this.captureError(uploadError)
      } else {
        this.signedIdTarget.value = blob.signed_id
      }
    })
  }

  validate(file) {
    const extension = this.extension(file)

    if (!this.acceptedFiles.includes(`.${extension.toLowerCase()}`)) return `${extension} files are not accepted.`
    if (file.size > this.maxFileSizeValue * 1024 * 1024) return `File is too big. Max file size is ${this.maxFileSizeValue}MB.`

    return null
  }

  showPreview(file) {
    this.fileNameTarget.textContent    = file.name
    this.fileDetailsTarget.textContent = this.fileDetails(file)
    this.errorTarget.textContent       = ''

    this.emptyStateTarget.classList.add('u-hide')
    this.previewTarget.classList.remove('u-hide')
  }

  fileDetails(file) {
    return `${this.humanSize(file.size)} · ${this.extension(file)}`
  }

  extension(file) {
    return file.name.split('.').pop().toUpperCase()
  }

  humanSize(bytes) {
    if (bytes < 1024) return `${bytes} Bytes`
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`

    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  }

  // ==== DirectUpload delegate

  directUploadWillStoreFileWithXHR(xhr) {
    this.xhr = xhr
    xhr.upload.addEventListener('progress', (event) => {
      const progress = Math.round((event.loaded / event.total) * 100)

      this.fileDetailsTarget.textContent = progress === 100 ? 'Finalising upload...' : `Uploading ${progress}%`
    })
  }

  // ==== Channels

}
